import { tv } from 'tailwind-variants';

export const languageSelectorVariants = tv({
  slots: {
    base: ['cursor-pointer relative group mx-4 my-1.5', 'rounded-[15px]'],
    labelWrapper: [
      'bg-light-gray rounded-[15px] ml-0.5',
      'text-light-black uppercase font-semibold text-[14px]',
      'px-0.5 py-1.5',
      'hover:text-secondary',
    ],
    labelEn: ['px-[12px] py-1.5'],
    labelEs: ['px-[12px] py-1.5'],
    mobileWrapper: ['relative inline-block'],
    mobileButton: ['flex flex-col items-center justify-center gap-1', 'cursor-pointer px-[16px]'],
    mobileIcon: ['text-secondary text-lg leading-none h-6 w-6 pt-1', 'fa-sharp fa-light fa-globe'],
    mobileLabel: ['font-medium text-nav-primary', 'text-[min(3.6vw,1rem)] leading-none'],
    tooltipWrapper: ['hidden lg:inline-block'],
    tooltip: [
      'absolute left-1/2 top-full -translate-x-1/2 mt-2',
      'whitespace-nowrap',
      'bg-black text-white',
      'text-xs font-medium',
      'px-3 py-1.5 rounded-md',
      'z-50',
      "before:content-['']",
      'before:absolute before:bottom-full before:-translate-x-1/2',
      'before:w-0 before:h-0',
      'before:border-x-[6px] before:border-x-transparent',
      'before:border-b-[6px] before:border-b-black',
    ],
  },
  variants: {
    isEnglish: {
      true: {
        labelEn: ['bg-nav-primary rounded-[14px]', 'text-white'],
      },
      false: {
        labelEs: ['bg-nav-primary rounded-[14px]', 'text-white'],
      },
    },
    isDisabled: {
      true: {
        mobileButton: ['cursor-not-allowed'],
        mobileIcon: ['text-[#979797]'],
        mobileLabel: ['text-[#979797]!'],
      },
      false: {},
    },
    isEnglishDisabled: {
      true: {
        labelEn: ['text-[#979797]'],
        tooltip: ['before:right-[70%]'],
      },
    },
    isSpanishDisabled: {
      true: {
        labelEs: ['text-[#979797]'],
        tooltip: ['before:left-[70%]'],
      },
    },
    hoverable: {
      true: {
        tooltip: [
          'pointer-events-none',
          'opacity-0 invisible',
          'transition-opacity duration-150',
          'group-hover:opacity-100 group-hover:visible group-focus:opacity-100 group-focus:visible',
        ],
      },
      false: {},
    },
    isMobile: {
      true: {
        tooltip: ['before:left-1/2'],
      },
    },
  },
  defaultVariants: {
    isEnglish: true,
    isDisabled: false,
    hoverable: false,
  },
});
